import { Component, OnInit, Type } from "@angular/core";
import { ICommand } from "../../../modules/records/commands/i-command";
import { IApiService } from "../../../modules/records/models/api/i-api-service";
import {
  ActionCol,
  IActionComponent
} from "../../table-col-configs/action-col";

@Component({
  selector: "app-detail-button",
  templateUrl: "./detail-button.component.html",
  styleUrls: ["./detail-button.component.scss"],
})
export class DetailButtonComponent<T extends object>
  implements OnInit, IActionComponent<T>
{
  data: string = "";
  commands: ICommand<T, IApiService<T>>[] = [];
  el!: T;

  constructor() {}

  ngOnInit(): void {}

  setComponentData(
    el: T,
    colConfig: ActionCol<T, Type<DetailButtonComponent<T>>, IApiService<T>>
  ) {
    this.data = colConfig.getElementData(el);
    this.commands = colConfig.commands;
    this.el = el;
  }

  onClick(index: number) {
    this.commands[index].execute(this.el);
    
  }
}
